import { Agent as HttpsAgent } from "https";

import { Express } from "express";
import { createProxyMiddleware, fixRequestBody } from "http-proxy-middleware";

import { SingletonController } from "../../Commons/HttpServer/ExpressWrapper/SingletonController";
import { ILogger } from "../../Commons/Logging/ILogger";
import { FarmProxyConfig } from "../../ReadFarmConfig";

export class BuildServerProxyController extends SingletonController {
    private readonly proxyConfig: Record<string, FarmProxyConfig>;
    private readonly logger: ILogger;

    public constructor(proxyConfig: Record<string, FarmProxyConfig>, logger: ILogger) {
        super();
        this.proxyConfig = proxyConfig;
        this.logger = logger;
    }

    public async setupMiddleware(expressApplication: Express): Promise<void> {
        const logger = this.logger;
        for (const [pattern, cfg] of Object.entries(this.proxyConfig)) {
            logger.log(`Proxy: ${pattern} -> ${cfg.target}`);

            const isHttpsTarget = String(cfg.target).startsWith("https:");
            const agent = isHttpsTarget ? new HttpsAgent({ rejectUnauthorized: false }) : undefined;

            expressApplication.use(
                pattern,
                createProxyMiddleware({
                    changeOrigin: true,
                    secure: false,
                    logLevel: "warn",
                    ...cfg,
                    agent: agent,
                    onProxyReq: (proxyReq, req) => {
                        logger.log(`[proxy ${pattern}] ${req.method} ${req.url}`);
                        fixRequestBody(proxyReq, req);
                    },
                    onError: (err, req, res) => {
                        const code = (err as NodeJS.ErrnoException).code ?? "ERR";
                        this.logger.warning(
                            `Proxy error on ${pattern} [${code}] ${req.url} -> ${cfg.target}: ${err.message}`
                        );
                        if ("headersSent" in res && !res.headersSent && "writeHead" in res) {
                            res.writeHead(502, { "Content-Type": "text/plain" });
                        }
                        if ("end" in res) {
                            res.end(`Bad Gateway (candy-tools proxy): [${code}] ${err.message}`);
                        }
                    },
                })
            );
        }
    }
}
